import useAxiosMutation from 'hooks/useAxiosMutation';
import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { SyntheticEvent } from 'react';
import { useQueryClient } from 'react-query';
import { FavouriteBlueprint } from 'types';

export const FAVOURITE_BLUEPRINTS_KEY = 'favourite-blueprints';

export const useFavouriteBlueprints = () => {
  const queryClient = useQueryClient();
  const key = [FAVOURITE_BLUEPRINTS_KEY];

  const { data: favouriteBlueprints, isLoading: isLoadingFavourites } = useAxiosQuery<{ data: FavouriteBlueprint[] }>(
    key,
    '/blueprints/favourites/',
    {
      mapper: (response: unknown) => {
        if (!response) {
          return { data: [] };
        }
        return response as { data: FavouriteBlueprint[] };
      },
    }
  );

  const { mutateAsync, isLoading: isLoadingMutation } = useAxiosMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(key);
    },
  });

  const addFavourite = (e: SyntheticEvent, blueprintId: number) => {
    e.preventDefault();
    mutateAsync({
      method: 'POST',
      path: `/blueprints/${blueprintId}/favourites/`,
    });
  };

  const removeFavourite = (e: SyntheticEvent, blueprintId: number) => {
    e.preventDefault();
    mutateAsync({
      method: 'DELETE',
      path: `/blueprints/${blueprintId}/favourites/`,
    });
  };

  const isFavourite = (blueprintId: number) => {
    return favouriteBlueprints?.data?.some((fav) => fav.blueprintId === blueprintId) ?? false;
  };

  return {
    favouriteBlueprints,
    addFavourite,
    removeFavourite,
    isFavourite,
    isLoading: isLoadingFavourites || isLoadingMutation,
  };
};
